<template>
  <div
      class="catalog-gallery"
      :id="`catalog-gallery_${id}`"
  >
      <slot/>
  </div>
</template>

<script>
    import $ from 'jquery';

    export default {
        name: 'CatalogGallery',
        data() {
            return {
                gallery: null,
                id: null,
            };
        },
        mounted() {
            this.id = this._uid;
        },
        methods: {
            playGallery({ currentTarget }) {
                const images = currentTarget.querySelectorAll('.catalog-gallery-image');
                if (images.length && images.length > 1) {
                    let activeId = 0;
                    this.gallery = setInterval(() => {
                        $(`#catalog-gallery_${this.id} > img:first`)
                            .fadeOut(500)
                            .removeClass('catalog-gallery-active')
                            .next()
                            .addClass('catalog-gallery-active')
                            .fadeIn(500)
                            .end()
                            .appendTo(`#catalog-gallery_${this.id}`);
                    }, 2000);
                }
            },
            stopGallery() {
                clearInterval(this.gallery);
            }
        },
    }
</script>


